import * as Scrivito from "scrivito";

const GlobalNewsWidget = Scrivito.provideWidgetClass("GlobalNewsWidget", {
  attributes: {
    eventCount: "integer",
    eventLink: "reference",
    eventHeadline: "string",
    newsHeadline: "string",
    newsCountPerPage: "integer",
    categoryFilter: "stringlist",
  },
  extractTextAttributes: ["eventHeadline", "newsHeadline"],
  onlyInside: ["GlobalNewsOverviewPage"],
});

export default GlobalNewsWidget;
